<template>
  <section class="catalog-page">
    <img class="catalog-background" :src="catalogImage" alt="报告目录页" />

    <svg
      v-if="catalogList.length"
      class="catalog-overlay"
      viewBox="0 0 2480 3508"
      preserveAspectRatio="none"
      role="img"
      aria-label="报告目录"
    >
      <g class="catalog-items" dominant-baseline="middle">
        <g
          v-for="(item, index) in catalogList"
          :key="item.number + '-' + item.title + '-' + index"
          class="catalog-item"
          :transform="'translate(0 ' + (1435 + index * 340) + ')'"
        >
          <text
            class="catalog-number"
            x="620"
            y="-30"
            fill="#68311d"
            font-size="116"
            font-weight="700"
          >{{ item.number }}</text>
          <text
            class="catalog-title"
            x="860"
            y="-30"
            fill="#68311d"
            font-size="116"
            font-weight="700"
          >{{ item.title }}</text>
          <text
            v-if="item.subTitle"
            class="catalog-subtitle"
            x="860"
            y="126"
            fill="#93644c"
            font-size="64"
            font-weight="500"
          >
            <tspan
              v-for="(line, lineIndex) in item.subTitleLines"
              :key="line + '-' + lineIndex"
              x="860"
              :dy="lineIndex === 0 ? 0 : 78"
            >{{ line }}</tspan>
          </text>
        </g>
      </g>
    </svg>
  </section>
</template>

<script>
import { REPORT_ASSETS } from '../reportAssets';

export default {
  name: 'CatalogPage',
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      catalogImage: REPORT_ASSETS.catalog,
    };
  },
  computed: {
    catalogList() {
      if (!Array.isArray(this.report.outline)) return [];

      return this.report.outline
        .map((item) => {
          const subTitle = this.normalizeText(item && item.subTitle);
          return {
            number: this.normalizeText(item && item.zh),
            title: this.normalizeText(item && item.title),
            subTitle,
            subTitleLines: this.wrapSubtitle(subTitle),
          };
        })
        .filter((item) => item.number || item.title || item.subTitle);
    },
  },
  methods: {
    normalizeText(value) {
      if (value == null) return '';
      return String(value).trim();
    },
    wrapSubtitle(value) {
      const text = this.normalizeText(value);
      const maxLineLength = 20;
      if (!text || text.length <= maxLineLength) return text ? [text] : [];

      if (text.length <= maxLineLength * 2) {
        const breakpoints = [];
        Array.from(text).forEach((character, index) => {
          const point = index + 1;
          if (
            '、，；。'.includes(character)
            && point <= maxLineLength
            && text.length - point <= maxLineLength
          ) breakpoints.push(point);
        });

        if (breakpoints.length) {
          const midpoint = text.length / 2;
          const splitAt = breakpoints.reduce((best, point) => {
            const distance = Math.abs(point - midpoint);
            const bestDistance = Math.abs(best - midpoint);
            return distance < bestDistance || (distance === bestDistance && point > best)
              ? point
              : best;
          });
          return [text.slice(0, splitAt), text.slice(splitAt)];
        }
      }

      const lines = [];
      for (let index = 0; index < text.length; index += maxLineLength) {
        lines.push(text.slice(index, index + maxLineLength));
      }
      return lines;
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-page {
  position: relative;
  width: 100%;
  min-height: 0;
  aspect-ratio: 210 / 297;
  overflow: hidden;
  background: #f7f0e2;
  isolation: isolate;
}

.catalog-background,
.catalog-overlay {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.catalog-background {
  z-index: 0;
  object-fit: fill;
}

.catalog-overlay {
  z-index: 1;
  pointer-events: none;
}

.catalog-items {
  font-family: "Source Han Sans SC", "Source Han Sans CN", "Noto Sans CJK SC",
    "PingFang SC", "Microsoft YaHei", sans-serif;
  line-height: 1;
}
</style>
